import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../components/Common/TextInput';
import CallOut from '../components/Common/CallOut';
import Notification from '../components/Common/Notification';
import { useAccounts } from '../DataStore/AccountsContext';
import ajaxAccountChart from '../util/remote/ajaxAccountChart';
import { useTheme } from '../DataStore/ThemeContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {
                ...state,
                accountTitle: initialState.accountTitle,
                accountDescription: initialState.accountDescription
            }
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
        accountNumber:"",
        accountTitle:"",
        accountDescription:"",
        info:"",
        loading: false,
}

const EditAccount = ({account, onComplete}) => {
    const [ info, setInfo ] = useState(null);
    const { setNotify, closeSettings, setSystemFunction } = useTheme();
    const {getChartOfAccounts, getAllAccounts} = useAccounts();
    
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        if(account){
            dispatch({ type: 'accountNumber', value: account.account_number });
            dispatch({ type: 'accountTitle', value: account.account_name });
            dispatch({ type: 'accountDescription', value: account.description });
        }
    }, [account]);

    useEffect(()=>{
        if(info){
            setTimeout(() => {
                setInfo(null);
            }, 5000);
        }
    }, [info]);

    useEffect(() => {
        setSystemFunction(() => async () => await handleSave());
        return () => setSystemFunction(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [state]);
    


    const handleSave = async () => {
        if (state.loading) {
            return;
        }
        dispatch({ type: 'loading', value: true });

        const server_response = await ajaxAccountChart.updateAccount(state.accountNumber, state.accountTitle, state.accountDescription, account.account_id);
        dispatch({ type: 'loading', value: false });

        if (server_response.status === 'OK') {
            setNotify(<Notification type="success" message={server_response.message} />);
            getChartOfAccounts(true);
            getAllAccounts(true);
            closeSettings();
            
        } else {
            setInfo(<Notification type="danger" message={server_response.message} />);
        }
    };

   

    return (
        <>
            <CallOut
                title="Account Updating"
                description="You cannot change the account hierarchy and account type, if need arises you might consider deleting the account instead."
            />
            <div className='mt-4'>{info}</div>
            <form className="form-horizontal" method="post" onSubmit={handleSave}>
                <TextInput
                    type="number"
                    label="Account number"
                    placeholder="Account number"
                    leftIcon="fa fa-university"
                    value={state.accountNumber}
                    onChange={(e) => dispatch({ type: 'accountNumber', value: e.target.value })}
                    required
                    wrap
                />

                <TextInput
                    type="text"
                    label="Account title"
                    placeholder="Account title"
                    leftIcon="fa fa-user-check"
                    value={state.accountTitle}
                    onChange={(e) => dispatch({ type: 'accountTitle', value: e.target.value })}
                    required
                    wrap
                />

                <TextInput
                    type="textarea"
                    label="Account description"
                    placeholder="Account description. Eg. ( What does this account track ? )"
                    leftIcon="fa fa-list"
                    value={state.accountDescription}
                    onChange={(e) => dispatch({ type: 'accountDescription', value: e.target.value })}
                    required
                    wrap
                />

               
            </form>
        </>
    );
};

export default EditAccount;

